import type { ComputedRef } from 'vue'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useCustomerStore } from '@stores/me/customer'
import { useOptionsStore } from '@stores/options'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

interface CurrentTimeReturn {
  currentTime: ComputedRef<string>
  currentTimeUtc: ComputedRef<string>
  currentDate: ComputedRef<string>
  currentDateUtc: ComputedRef<string>
}

export const useCurrentTime = (): CurrentTimeReturn => {
  const customerStore = useCustomerStore()
  const optionsStore = useOptionsStore()

  const currentTime = computed(() => {
    const deviceCurrentTime = dayjs().tz(customerStore.customer!.timezone).format(DateFormat.Default)
    return optionsStore.getCurrentTime || deviceCurrentTime
  })
  const currentTimeUtc = computed(() => {
    const deviceCurrentTimeUtc = dayjs().utc().format(DateFormat.Default)
    return optionsStore.getCurrentTimeUtc || deviceCurrentTimeUtc
  })

  const currentDate = computed(() => {
    return dayjs(currentTime.value, DateFormat.Default).format(DateFormat.DefaultDate)
  })
  const currentDateUtc = computed(() => {
    return dayjs(currentTimeUtc.value, DateFormat.Default).format(DateFormat.DefaultDate)
  })

  return {
    currentTime,
    currentTimeUtc,
    currentDate,
    currentDateUtc,
  }
}

interface RawCurrentTimeReturn {
  currentTime: string
  currentTimeUtc: string
  currentDate: string
  currentDateUtc: string
}

export const useRawCurrentTime = (): RawCurrentTimeReturn => {
  const customerStore = useCustomerStore()
  const optionsStore = useOptionsStore()

  const deviceCurrentTime = dayjs().tz(customerStore.customer!.timezone).format(DateFormat.Default)
  const deviceCurrentTimeUtc = dayjs().utc().format(DateFormat.Default)

  const currentTime = optionsStore.getCurrentTime || deviceCurrentTime
  const currentTimeUtc = optionsStore.getCurrentTimeUtc || deviceCurrentTimeUtc

  const currentDate = dayjs(currentTime, DateFormat.Default).format(DateFormat.DefaultDate)
  const currentDateUtc = dayjs(currentTimeUtc, DateFormat.Default).format(DateFormat.DefaultDate)

  return {
    currentTime,
    currentTimeUtc,
    currentDate,
    currentDateUtc,
  }
}
